
import { Vue, Options, prop } from "vue-class-component";
import Title from "@/app/ui/components/data-wrapper/title.vue";

interface District {
  name: string;
}

interface PartnerAreaDelivery {
  cityCode: string;
  cityName: string;
  districts: District[];
}

interface DetailData {
  partnerAreaDeliveries: PartnerAreaDelivery[];
}

class Props {
  detailData = prop<DetailData>({
    type: Object,
    required: true
  });
}

@Options({
  components: {
    Title
  }
})
export default class DetailAreaDelivery extends Vue.with(Props) {
  public isShowDistrictDialog = false;
  public dialogTitle = "";
  public dialogDistricts: District[] = [];

  public openDistrictDialog(index: number): void {
  const item = this.detailData?.partnerAreaDeliveries?.[index];

  if (item) {
    this.dialogTitle = `${item.cityCode || "-"} - ${item.cityName || "-"}`;
    this.dialogDistricts = item.districts || []; // ← perbaikan
    this.isShowDistrictDialog = true;
  }
}



  public closeDistrictDialog(): void {
    this.isShowDistrictDialog = false;
    this.dialogTitle = "";
    this.dialogDistricts = [];
  }
}
